// import type { Components } from '@mui/material/styles';

import { RootContainers } from '@/modules/common/helpers';

export default function MUIMenu() /* : Components['MuiMenu'] */ {
  return {
    defaultProps: {
      container: RootContainers.getMUIPortalContainer(),
      disableScrollLock: true,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
      },
    },
    // variants: [],
  };
}
